import { Routes } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { NoAccessComponent, PageNotFoundComponent } from '../shared';
import { AuthGuard, HasAccessGuard } from '../core';
const ɵ0 = { title: "PageTitle.Home" }, ɵ1 = () => import("./../pages/dashboard/dashboard.module.ngfactory").then(m => m.DashboardModuleNgFactory), ɵ2 = { title: "PageTitle.Dashboard", preload: true }, ɵ3 = () => import("./../pages/baskets/baskets.module.ngfactory").then(m => m.BasketsModuleNgFactory), ɵ4 = { title: "PageTitle.Baskets", preload: true }, ɵ5 = () => import("./../pages/vehicles/vehicles.module.ngfactory").then(m => m.VehiclesModuleNgFactory), ɵ6 = { title: "PageTitle.FindVehicle", preload: true }, ɵ7 = () => import("./../pages/related/related.module.ngfactory").then(m => m.RelatedModuleNgFactory), ɵ8 = { title: "PageTitle.FindVehicle", preload: true }, ɵ9 = () => import("./../pages/reports/reports.module.ngfactory").then(m => m.ReportsModuleNgFactory), ɵ10 = { title: "PageTitle.Reports", preload: true }, ɵ11 = () => import("./../pages/admin/admin.module.ngfactory").then(m => m.AdminModuleNgFactory), ɵ12 = { title: "PageTitle.Admin", preload: false }, ɵ13 = () => import("./../pages/charts/charts.module.ngfactory").then(m => m.ChartsModuleNgFactory), ɵ14 = { title: "PageTitle.Charts", preload: true }, ɵ15 = () => import("./../pages/privacynotice/privacynotice.module.ngfactory").then(m => m.PrivacyNoticeModuleNgFactory), ɵ16 = { title: "Pagetitle.privacyNotice", preload: true }, ɵ17 = { title: "PageTitle.PageNotFound" };
const appRoutes = [
    { path: HomeComponent.route, component: HomeComponent, pathMatch: 'full', data: ɵ0 },
    //{ path: '', redirectTo: HomeComponent.route, pathMatch: 'full' },//not use, because PageNotFound
    //Lazy Loading Reports Modules
    //Note: keep path in sync with sidebar
    //      keep loadChildren in sync with module's file location
    {
        path: 'dashboard', loadChildren: ɵ1,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: ɵ2
    },
    {
        path: 'baskets', loadChildren: ɵ3,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: ɵ4
    },
    {
        path: 'find-vehicles', loadChildren: ɵ5,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: ɵ6
    },
    {
        path: 'related', loadChildren: ɵ7,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: ɵ8
    },
    {
        path: 'reports', loadChildren: ɵ9,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: ɵ10
    },
    {
        path: 'admin', loadChildren: ɵ11,
        /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard], canActivateChild: [AuthGuard], data: ɵ12
    },
    {
        path: 'charts', loadChildren: ɵ13, data: ɵ14
    },
    //{ path: 'unauthorised', component: UnauthorisedComponent },
    { path: NoAccessComponent.route, component: NoAccessComponent },
    { path: 'privacyNotice',
        loadChildren: ɵ15, data: ɵ16
    },
    //Note: keep it last ( no default view )
    { path: PageNotFoundComponent.route /*  '**'  */, component: PageNotFoundComponent, data: ɵ17 },
];
export class AppRoutingModule {
}
export const routableComponents = [
    HomeComponent,
];
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17 };
